import { normalizeWidgetTheme, APIURL, cancelSelectEvent, changeSymbolForWidget, getCSSStyles, getWidgetDataURI, apiGet, toggleWidgetTheme, isHeaderPinned, getHeaderPinStateClass, getHeaderPinButtonHTML, setupHeaderPin } from '../../helpers';
import { WidgetConfig, WidgetEvent, WidgetEventHandler, WidgetEventType } from '../../types';

export class TraderverseStockSplits {
    private container: HTMLElement;
    private config: WidgetConfig;
    private eventHandlers: Map<WidgetEventType, WidgetEventHandler[]> = new Map();
    private updateInterval: number | null = null;
    private shadowRoot: ShadowRoot;
    private currentData: any = null;
    private currentChart: any;
    private widgetResizeObserver: ResizeObserver | null = null;
    private currentInterval: string = '1w';
        private isLoading: boolean = true;
    private outsideClickHandler: ((ev: MouseEvent) => void) | null = null;

    constructor(config: WidgetConfig) {
        this.config = { ...this.getDefaultConfig(), ...config };
        this.config.theme = normalizeWidgetTheme(this.config.theme);
        this.container = this.resolveContainer(config.container);

        if ((this.container as any).shadowRoot) {
            this.shadowRoot = (this.container as any).shadowRoot;
        } else {
            this.shadowRoot = this.container.attachShadow({ mode: 'closed' });
        }
        this.init();

        this.widgetResizeObserver = new ResizeObserver(() => {
            this.updateDisplay();
        });
        setTimeout(() => {
            const widget = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
            if (widget) this.widgetResizeObserver?.observe(widget);
        }, 0);
    }

    private fetchSymbols(): Array<{ value: string; label: string }> {
        return [
            { label: 'AAPL', value: 'AAPL' }, { label: 'MSFT', value: 'MSFT' },
            { label: 'GOOGL', value: 'GOOGL' }, { label: 'AMZN', value: 'AMZN' },
            { label: 'NVDA', value: 'NVDA' }, { label: 'META', value: 'META' },
            { label: 'TSLA', value: 'TSLA' }, { label: 'AVGO', value: 'AVGO' },
            { label: 'PEP', value: 'PEP' }, { label: 'COST', value: 'COST' }
        ];
    }

    private getDefaultConfig(): Partial<WidgetConfig> {
        const symbols = this.fetchSymbols();
        return {
      headerPinned: true,
            symbol: symbols[0].value,
            theme: 'default-dark',
            width: '100%',
            height: '400px',
            autosize: true,
        };
    }

    private resolveContainer(container: string | HTMLElement): HTMLElement {
        if (typeof container === 'string') {
            const el = document.getElementById(container) || document.querySelector(container);
            if (!el) throw new Error(`Container not found: ${container}`);
            return el as HTMLElement;
        }
        return container;
    }

    private async init(): Promise<void> {
        if (!this.config.symbol) this.config.symbol = this.fetchSymbols()[0].value;
        this.isLoading = true;
        this.createWidget();
        await this.attachStyles();
        this.currentData = null;
        this.updateDisplay();
        this.emit('ready', {});
        this.config.onReady?.();
        this.setupChart();
        cancelSelectEvent(this.shadowRoot);
    }

    private createWidget(): void {
        let themeClass = 'defaultDarkMode';
      let dataTheme = 'default-dark';
      
      if (this.config.theme === 'white') {
        themeClass = 'whiteMode';
        dataTheme = 'white';
      } else if (this.config.theme === 'black') {
        themeClass = 'blackMode';
        dataTheme = 'black';
      } else if (this.config.theme === 'default-lite') {
  themeClass = 'defaultLightMode';
  dataTheme = 'default-lite';
}
        const widgetHtml = `
            <div style="width: ${typeof this.config.width == "number" ? this.config.width+ 'px' : this.config.width  };height: ${typeof this.config.height == "number" ? this.config.height+ 'px' : this.config.height};" class="widgetBox ${themeClass} loading ${getHeaderPinStateClass(this.config)}" data-theme="${dataTheme}" data-theme="${this.config.theme}">
                <div class="headTop">
                    <h4 class="title market">${this.getTitleIconSvg()} Stock Splits </h4>
                    <div class="actionCol">${getHeaderPinButtonHTML(this.config)}</div>
                </div>
                <div class="inBody">
                    <div class="optionsRow">
                        

                            <div class="item">
                                <select class="filter-split-type">
                                    <option value="All">All</option>
                                    <option value="Forward">Forward</option>
                                    <option value="Reversed">Reversed</option>
                                </select>
                            </div>
                        <span></span>

                            <div class="item">
                                <p>Min Ratio </p>
                                <input type="number" class="filter-min-ratio" min="1" step="1" style="width:72px;margin-left:6px" value="${(this.config as any).p_min_ratio || 10}" />
                            </div>
                    </div>

                    

                    <div class="chartDv" id="topIndexContainer"></div>
                </div>
            </div>
                `;
        this.shadowRoot.innerHTML = widgetHtml;
    setupHeaderPin(this.shadowRoot, this.config);
        const splitTypeEl = this.shadowRoot.querySelector('.filter-split-type') as HTMLSelectElement | null;
        const minRatioEl = this.shadowRoot.querySelector('.filter-min-ratio') as HTMLInputElement | null;

        if (splitTypeEl) {
            splitTypeEl.value = String((this.config as any).p_split_type || 'All');
            splitTypeEl.addEventListener('change', () => {
                (this.config as any).p_split_type = splitTypeEl.value;
                this.setupChart();
            });
        }

        if (minRatioEl) {
            minRatioEl.addEventListener('change', () => {
                const val = parseInt(minRatioEl.value || '10', 10);
                (this.config as any).p_min_ratio = isNaN(val) || val < 1 ? 10 : val;
                this.setupChart();
            });
        }

        const filtersBox = this.shadowRoot.querySelector('.filtersBox') as HTMLElement | null;
        const filtersBtn = this.shadowRoot.querySelector('.optionsRow button') as HTMLButtonElement | null;
            if (filtersBtn && filtersBox) {
            filtersBtn.addEventListener('click', (ev: MouseEvent) => {
                ev.stopPropagation();
                filtersBox.classList.toggle('hidden');
            });

            filtersBox.addEventListener('click', (ev: MouseEvent) => ev.stopPropagation());
            filtersBox.addEventListener('pointerdown', (ev: PointerEvent) => ev.stopPropagation());
            if (splitTypeEl) splitTypeEl.addEventListener('pointerdown', (ev: PointerEvent) => ev.stopPropagation());
            if (minRatioEl) minRatioEl.addEventListener('pointerdown', (ev: PointerEvent) => ev.stopPropagation());

            this.outsideClickHandler = (ev: MouseEvent) => {
                try {
                    const path = (ev as any).composedPath ? (ev as any).composedPath() : (ev as any).path || [];
                    const clickedInside = Array.isArray(path) && path.some((node: any) => {
                        try {
                            return node && node.getRootNode && node.getRootNode() === this.shadowRoot;
                        } catch (e) {
                            return false;
                        }
                    });
                    if (!clickedInside) {
                        filtersBox.classList.add('hidden');
                    }
                } catch (e) {
                    filtersBox.classList.add('hidden');
                }
            };
            document.addEventListener('click', this.outsideClickHandler);
        }
    }

    private async attachStyles(): Promise<void> {
        try {
            const styleEl = await getCSSStyles();
            this.shadowRoot.appendChild(styleEl);
        } catch (err) {
            console.error('Failed to load CSS file:', err);
        }
    }


    private async setupChart(): Promise<void> {
        try {
            const splitType = (this.config as any).p_split_type || 'All';
            const minRatio = (this.config as any).p_min_ratio || 10;
            const url = `${APIURL}/v1/discover/stock-split?splitType=${splitType}&minRatio=${minRatio}`;

            const response = await apiGet({
                method: 'GET',
                url,
                headers: { 'Content-Type': 'application/json' }
            });

            if (!response.ok) throw new Error("Failed to fetch data");
            const data = await response.json();
            const items = Array.isArray(data) ? data : (data && (data.data || data.items || data.results)) || [];
            this.currentData = items;
            this.isLoading = false;
            this.updateDisplay();
            this.emit('dataUpdate', this.currentData);
        } catch (err) {
            console.error("Error fetching chart data:", err);
            this.currentData = [];
            this.updateDisplay();
        }
    }


    private updateDisplay(): void {
        const widget = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
        if (widget) {
            if (this.isLoading) {
                widget.classList.add('loading');
            } else {
                widget.classList.remove('loading');
            }
        }
        if (!this.currentData) {
            return;
        }
        this.renderAnalystRating();
    }


   

   private renderAnalystRating(): void {
    const container = this.shadowRoot.querySelector('#topIndexContainer') as HTMLElement;
    if (!container) return;

    const items = Array.isArray(this.currentData)
        ? this.currentData
        : (this.currentData && (this.currentData.data || this.currentData.items)) || [];

    if (!Array.isArray(items) || items.length === 0) {
        container.removeAttribute('data-testing-id');
        container.innerHTML = `
            <div class="noData">
                <p>No data available</p>
            </div>
        `;
        return;
    }

    const limitedItems = items.slice(0, 20);

    const cards = limitedItems.map((item: any) => {
        const badgeClass = item.split_type_out === 'Reverse' ? 'red' : '';

        const splitDateFormatted = new Date(item.split_date)
            .toLocaleDateString('en-US', {
                year: '2-digit',
                month: '2-digit',
                day: '2-digit'
            })
            .replace(/\//g, '-');

        const ratioText = `${item.numerator}:${item.denominator} - ${splitDateFormatted}`;

        const roundedRatio =
            typeof item.ratio === 'number'
                ? item.ratio.toFixed(2)
                : item.ratio;

        return `
            <div class="item">
                <div class="mainRow rowitm">
                    <div class="colItm">
                        <h4>${item.symbol}</h4>
                    </div>
                    <div class="colItm">
                        <span class="badge btnBagde ${badgeClass}">
                            ${item.split_type_out}
                        </span>
                    </div>
                </div>

                <div class="subRow rowitm">
                    <div class="colItm">
                        <p class="text-white">
                            <strong>${item.numerator}:${item.denominator}</strong> Split
                        </p>
                    </div>

                    <div class="colItm text-center">
                        <p>
                            <arrow>
                                <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.2 5.5L7.70001 -2.40413e-07L6.92451 0.7755L11.0935 4.95L1.0274e-05 4.95L1.0226e-05 6.05L11.0935 6.05L6.92451 10.2245L7.70001 11L13.2 5.5Z" fill="#3FA2FF"/>
                                </svg>
                            </arrow>
                            ${ratioText}
                        </p>
                    </div>

                    <div class="colItm text-right">
                        <p class="text-white">
                            <strong class="text-blue">${roundedRatio}x</strong> Ratio
                        </p>
                    </div>
                </div>
            </div>
        `;
    }).join('');

    const html = `
        <div class="stockSplitMain">
            <div class="inner">
                ${cards}
            </div>
        </div>
    `;

    container.innerHTML = html;

    // Add testing-id only when UI items are actually rendered
    const renderedItems = container.querySelectorAll('.item');

    if (renderedItems.length > 0) {
        container.setAttribute('data-testing-id', 'stock-splits');
    } else {
        container.removeAttribute('data-testing-id');
    }
}

    private changeSymbol(stockId: string, stock: any = null): void {
        changeSymbolForWidget(this.shadowRoot, this.config, stock, stockId, (stockId: any) => this.setupChart(), (type: any, data: any) => this.emit(type, data));
    }

    public on(type: WidgetEventType, handler: WidgetEventHandler): void {
        if (!this.eventHandlers.has(type)) this.eventHandlers.set(type, []);
        this.eventHandlers.get(type)!.push(handler);
    }
    public off(type: WidgetEventType, handler: WidgetEventHandler): void {
        const list = this.eventHandlers.get(type);
        if (list) this.eventHandlers.set(type, list.filter(h => h !== handler));
    }
    public setSymbol(symbol: string): void {
        this.changeSymbol(symbol);
        const dropdown = this.shadowRoot.querySelector('.symbol-dropdown') as HTMLSelectElement;
        if (dropdown) dropdown.value = symbol;
    }
    public async getWidgetImage(): Promise<string> {
        const widget = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
        return await getWidgetDataURI(widget);
    }
  
    public setTheme(theme: 'white' | 'black' | 'default-dark' | 'default-lite' | 'default-lite'): void {
      if (!this.shadowRoot) return;
    
      this.config.theme = toggleWidgetTheme(
        this.shadowRoot,
        theme
      ) as 'white' | 'black' | 'default-dark' | 'default-lite' | 'default-lite';
    
      this.updateDisplay();
    }
    public destroy(): void {
        if (this.updateInterval) { clearInterval(this.updateInterval); this.updateInterval = null; }
        if (this.widgetResizeObserver) { this.widgetResizeObserver.disconnect(); this.widgetResizeObserver = null; }
        if (this.outsideClickHandler) {
            document.removeEventListener('click', this.outsideClickHandler);
            this.outsideClickHandler = null;
        }
        this.eventHandlers.clear(); this.shadowRoot.innerHTML = '';
    }
    private emit(type: WidgetEventType, data: any): void {
        const handlers = this.eventHandlers.get(type);
        if (handlers) { const evt: WidgetEvent = { type, data }; handlers.forEach(h => h(evt)); }
    }
    private getTitleIconSvg(): string {
      return `<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M18.75 28.4375H11.25C4.4625 28.4375 1.5625 25.5375 1.5625 18.75V11.25C1.5625 4.4625 4.4625 1.5625 11.25 1.5625H18.75C25.5375 1.5625 28.4375 4.4625 28.4375 11.25V18.75C28.4375 25.5375 25.5375 28.4375 18.75 28.4375ZM11.25 3.4375C5.4875 3.4375 3.4375 5.4875 3.4375 11.25V18.75C3.4375 24.5125 5.4875 26.5625 11.25 26.5625H18.75C24.5125 26.5625 26.5625 24.5125 26.5625 18.75V11.25C26.5625 5.4875 24.5125 3.4375 18.75 3.4375H11.25Z" fill="currentColor"/> <path d="M9.16252 19.05C8.96252 19.05 8.76252 18.9875 8.58752 18.85C8.17502 18.5375 8.10002 17.95 8.41252 17.5375L11.3875 13.675C11.75 13.2125 12.2625 12.9125 12.85 12.8375C13.425 12.7625 14.0125 12.925 14.475 13.2875L16.7625 15.0875C16.85 15.1625 16.9375 15.1625 17 15.15C17.05 15.15 17.1375 15.125 17.2125 15.025L20.1 11.3C20.4125 10.8875 21.0125 10.8125 21.4125 11.1375C21.825 11.45 21.9 12.0375 21.575 12.45L18.6875 16.175C18.325 16.6375 17.8125 16.9375 17.225 17C16.6375 17.075 16.0625 16.9125 15.6 16.55L13.3125 14.75C13.225 14.675 13.125 14.675 13.075 14.6875C13.025 14.6875 12.9375 14.7125 12.8625 14.8125L9.88752 18.675C9.72502 18.925 9.45002 19.05 9.16252 19.05Z" fill="currentColor"/> </svg>`;
    }

}

declare global { interface Window { TraderverseStockSplits: typeof TraderverseStockSplits; } }
if (typeof window !== 'undefined') { window.TraderverseStockSplits = TraderverseStockSplits; }